import * as React from "react"
import { Box, Typography } from "@mui/material"
import {translateCountryName} from "@ui-seeker/utils";

import { LabelCountry } from "@components"
import { boxListCountries } from "./styles"


export default function ListCountries({ countries }) {
    return <Box sx={ boxListCountries }>
		{ countries.map((name, idx) => <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
                <Typography component="div" variant="body2">
                    <LabelCountry country={name} label={translateCountryName(name)} ellipsis={true} />
                </Typography>
            </Box>
        )}
	</Box>
}